// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminblock{background: #0075BB;
    border-radius: 12px;
    height: 130px;
    font-size: 20px;
    font-weight: bold;
    color: #fff;    padding-top: 20px;cursor: pointer}

    .adminblock1{background: #01A7C6;
        border-radius: 12px;
        height: 130px;font-size: 20px;
        font-weight: bold;
        color: #fff;    padding-top: 20px;cursor: pointer}
.user-main-content{margin-top: 20px;}
tr th{    background: #0075BB;
    color: #fff;
}

tr th:first-child {
    border-radius: 14px 0 0 0;
}
tr th:last-child {
    border-radius: 0 14px 0 0;
}
.table-responsive {
   
    width: 97%;
    margin: 0 auto;
}
/* tbody tr td:first-child{border-left: 1px solid #0075BB}
tbody tr td:last-child{border-right: 2px solid #0075BB}
.table{border-bottom: 1px solid #0075BB} */

.table>thead>tr>th {
    vertical-align: bottom;
     border-bottom: 0px ; 
}

/* created by rahul nakra*/

.card-back{
    border-radius:15px;
}

.table{
    border: 1px solid #0075BB;
    border-radius: 15px;
    float: left;
    max-width: 100%;
    border-collapse: inherit;
}

.card .title-heading {
    padding: 5px 20px;
    color: #333;
    font-size: 16px;
    font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/admin-dashboard/admin-dashboard.component.css"],"names":[],"mappings":"AAAA,YAAY,mBAAmB;IAC3B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW,KAAK,iBAAiB,CAAC,eAAe;;IAEjD,aAAa,mBAAmB;QAC5B,mBAAmB;QACnB,aAAa,CAAC,eAAe;QAC7B,iBAAiB;QACjB,WAAW,KAAK,iBAAiB,CAAC,eAAe;AACzD,mBAAmB,gBAAgB,CAAC;AACpC,UAAU,mBAAmB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,UAAU;IACV,cAAc;AAClB;AACA;;0CAE0C;;AAE1C;IACI,sBAAsB;KACrB,mBAAmB;AACxB;;AAEA,0BAA0B;;AAE1B;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB","sourcesContent":[".adminblock{background: #0075BB;\r\n    border-radius: 12px;\r\n    height: 130px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    color: #fff;    padding-top: 20px;cursor: pointer}\r\n\r\n    .adminblock1{background: #01A7C6;\r\n        border-radius: 12px;\r\n        height: 130px;font-size: 20px;\r\n        font-weight: bold;\r\n        color: #fff;    padding-top: 20px;cursor: pointer}\r\n.user-main-content{margin-top: 20px;}\r\ntr th{    background: #0075BB;\r\n    color: #fff;\r\n}\r\n\r\ntr th:first-child {\r\n    border-radius: 14px 0 0 0;\r\n}\r\ntr th:last-child {\r\n    border-radius: 0 14px 0 0;\r\n}\r\n.table-responsive {\r\n   \r\n    width: 97%;\r\n    margin: 0 auto;\r\n}\r\n/* tbody tr td:first-child{border-left: 1px solid #0075BB}\r\ntbody tr td:last-child{border-right: 2px solid #0075BB}\r\n.table{border-bottom: 1px solid #0075BB} */\r\n\r\n.table>thead>tr>th {\r\n    vertical-align: bottom;\r\n     border-bottom: 0px ; \r\n}\r\n\r\n/* created by rahul nakra*/\r\n\r\n.card-back{\r\n    border-radius:15px;\r\n}\r\n\r\n.table{\r\n    border: 1px solid #0075BB;\r\n    border-radius: 15px;\r\n    float: left;\r\n    max-width: 100%;\r\n    border-collapse: inherit;\r\n}\r\n\r\n.card .title-heading {\r\n    padding: 5px 20px;\r\n    color: #333;\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
